<template>
  <v-col class="kw-field">
    <v-row no-gutters align="center">
      <v-col cols="2" class="pa-0">
        <v-text-field
          :readonly="!canEdit"
          :disabled="isCopied"
          :rules="notEmpty"
          v-model="fieldCourt"
          outlined
          type="text"
          @change="updateKwField"
        />
      </v-col>
      <v-col cols="auto" class="pb-7">
        {{ '/' }}
      </v-col>
      <v-col cols="5" class="pa-0">
        <v-text-field
          :readonly="!canEdit"
          :disabled="isCopied"
          :rules="notEmpty"
          v-model="fieldNumber"
          outlined
          type="text"
          @change="updateKwField"
        />
      </v-col>
      <v-col cols="auto" class="pb-7">
        {{ '/' }}
      </v-col>
      <v-col cols="2" class="pa-0">
        <v-text-field
          :readonly="!canEdit"
          :disabled="isCopied"
          :rules="notEmpty"
          v-model="fieldDigit"
          outlined
          type="text"
          @change="updateKwField"
        />
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
export default {
  props: {
    attribute: {
      type: Object,
      required: true
    },
    canEdit: {
      type: Boolean,
      required: true
    },
    isCopied: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: () => ({
    fieldCourt: '',
    fieldNumber: '',
    fieldDigit: ''
  }),
  computed: {
    notEmpty() {
      return [];
      // return [field => !!field || ''];
    }
  },
  methods: {
    updateKwField() {
      if (this.fieldCourt && this.fieldNumber && this.fieldDigit) {
        this.attribute.value = `${this.fieldCourt}/${this.fieldNumber}/${this.fieldDigit}`;
      } else {
        this.attribute.value = null;
      }
    }
  },
  mounted() {
    if (this.attribute.value != null && this.attribute.value != undefined) {
      const KwSplit = this.attribute.value.split('/');
      this.fieldCourt = KwSplit[0];
      this.fieldNumber = KwSplit[1];
      this.fieldDigit = KwSplit[2];
    }
  }
};
</script>
<style>
.kw-field {
  display: inherit;
  font-size: 34px;
  padding: 0;
}
</style>